module.exports = __webpack_public_path__ + "static/media/480.842df8d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-construction/light/480.png
// module id = 1972
// module chunks = 2